module.exports = __webpack_public_path__ + "static/media/skill10.68da6387.jpeg";